import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Header from "./components/Header";
import ProductShowcase from "./components/ProductShowcase";
import FeaturesSection from "./components/FeaturesSection";
import CustomerReviews from "./components/CustomerReviews";
import FAQsSection from "./components/FAQsSection";
import CheckoutSection from "./components/CheckoutSection";

function App() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setTimeout(() => {
      fetch("https://services.fluxi.co/api/ms/ecommerce-service/websites/365eeea4d67f420ab2c3194e3131922", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "owner-id": "6793d49b37d46cb317d42898",
        },
      })
        .then((response) => {
          if (!response.ok) throw new Error("Error en la solicitud");
          return response.json();
        })
        .then((data) => {
          setData(data);
          setLoading(false);
        })
        .catch((error) => {
          setError(error.message);
          setLoading(false);
        });
    }, 1000); // Mantiene el loader visible por al menos 2 segundos
  }, []);

  return (
    <div className="font-sans">
      <AnimatePresence>
        {loading ? (
          // Loader con animación de salida suave
          <motion.div
            key="loader"
            initial={{ opacity: 1, scale: 1 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            transition={{ duration: 0.8, ease: "easeInOut" }}
            className="flex flex-col justify-center items-center h-screen bg-gradient-to-r from-blue-100 to-blue-300 text-white"
          >
            {/* Loader con partículas animadas */}
            <div className="relative flex justify-center items-center">
              <div className="absolute w-24 h-24 border-4 border-t-transparent border-white rounded-full animate-spin"></div>
              <div className="w-16 h-16 border-4 border-t-transparent border-yellow-300 rounded-full animate-spin-reverse"></div>
            </div>

            {/* Texto animado: "✨ Haciendo magia..." */}
            <motion.p
              className="mt-6 text-lg font-semibold text-gray-800"
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ repeat: Infinity, duration: 1.5, ease: "easeInOut" }}
            >
              ✨ Haciendo magia... ✨
            </motion.p>
          </motion.div>
        ) : error ? (
          // Página de error con animación de entrada
          <motion.div
            key="error"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="flex justify-center items-center h-screen bg-gray-100"
          >
            <p className="text-red-500 text-lg font-semibold">Error: {error}</p>
          </motion.div>
        ) : (
          // Página principal con animación de entrada suave
          <motion.main
            key="main"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="bg-gray-50"
          >
            <Header />
            <ProductShowcase product={data} />
            <FeaturesSection features={data.copies.Benefits.Benefits_list} data={data} />
            <CustomerReviews testimonials={data.copies.Testimonials.Testimonials_list} />
            <FAQsSection faqs={data.copies.FAQs} />
            <CheckoutSection product={data} />
          </motion.main>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
